"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsSocialLinkedinButton", function() {
    return {
        restrict    : "E",
        scope       : true,
        replace     : true,
        template    : require("./obsSocialLinkedinButton.html"),
        link : function($scope, $el, $attrs) {

            $('<script src="//platform.linkedin.com/in.js" type="text/javascript">lang: fr_FR</script>' +
              '<script type="IN/Share"></script>').appendTo($el);

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/social/obsSocialLinkedinButton.js